import React, { Component } from 'react';
import Modal from 'react-modal';

class WorkConfidenceSetAppElement extends Component {
    render() {
        return (
            <div>{Modal.setAppElement('#work-confidence-button')}</div>
        );
    }
};

export default WorkConfidenceSetAppElement;

// export const WorkConfidenceSetAppElement = () => {
//     Modal.setAppElement('#work-confidence-button')
// }